// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"553352ce","250":"2a1dbf09","407":"88ee7f0b","436":"7f10d85b","453":"f394a27d","455":"2b9dbaca","501":"7fc14dce","595":"97e7865a","606":"b8b90612","691":"fbbf0b85","821":"074e5e1e","880":"ca6c3794","925":"b28d5a91","969":"813f93b1"}[chunkId] + ".chunk.js";
};